/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const TransactionAlert = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M2.5 22H1V12C1 5.92487 5.92487 1 12 1H12.5C18.299 1 23 5.70101 23 11.5C23 17.299 18.299 22 12.5 22H5V20.5H12.5C17.3818 20.5 21.3558 16.6132 21.4962 11.7654L21.5 11.5C21.5 6.52944 17.4706 2.5 12.5 2.5H12C6.75329 2.5 2.5 6.75329 2.5 12V22ZM12.344 6V7.04C13.808 7.256 14.78 8.192 14.876 9.572H13.292C13.184 8.936 12.608 8.408 11.684 8.408C10.832 8.408 10.328 8.756 10.328 9.356C10.328 9.884 10.712 10.136 11.3 10.304L12.716 10.7C13.928 11.048 14.96 11.624 14.96 13.292C14.96 14.672 13.952 15.62 12.344 15.8V17H11V15.764C9.488 15.5 8.444 14.408 8.348 12.824H9.932C10.004 13.736 10.784 14.432 11.768 14.432C12.692 14.432 13.328 13.988 13.328 13.328C13.328 12.74 12.884 12.404 12.284 12.236L10.868 11.84C9.68 11.504 8.684 10.892 8.684 9.368C8.684 8.168 9.62 7.268 11 7.04V6H12.344Z"
                        fill={color}
                    />
                </svg>
        );
    };
